import { render, staticRenderFns } from "./OrdensServicoSearch.vue?vue&type=template&id=4ca3a762&scoped=true&"
import script from "./OrdensServicoSearch.vue?vue&type=script&lang=js&"
export * from "./OrdensServicoSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca3a762",
  null
  
)

export default component.exports